<div class="user-dialog">
  <header class="user-dialog__header">
    <div class="user-dialog__badge" [class.user-dialog__badge--add]="action === EAction.Add">
      <span *ngIf="action === EAction.Edit">{{ initials }}</span>
      <i class="material-icons" *ngIf="action === EAction.Add">person_add</i>
    </div>
    <div class="user-dialog__heading">
      <h2 class="user-dialog__title">
        {{ action === EAction.Add ? "Add user" : "Edit user" }}
      </h2>
      <p class="user-dialog__subtitle">
        <ng-container *ngIf="action === EAction.Add">
          Invite a colleague and choose the locations they can access.
        </ng-container>
        <ng-container *ngIf="action === EAction.Edit">
          {{ user?.firstName }} {{ user?.lastName }} · {{ user?.username }}
        </ng-container>
      </p>
    </div>
    <button
      type="button"
      mat-icon-button
      mat-dialog-close
      class="user-dialog__close"
      aria-label="Close"
    >
      <i class="material-icons">close</i>
    </button>
  </header>

  <form [formGroup]="userForm" (ngSubmit)="onSubmit()" class="user-dialog__form">
    <div class="user-dialog__body">
      <section class="form-section">
        <h3 class="form-section__title">Details</h3>

        <div class="form-grid">
          <mat-form-field appearance="outline">
            <mat-label>First name</mat-label>
            <input
              matInput
              type="text"
              [formControl]="userForm.controls.firstName"
              placeholder="First name"
            />
            <mat-error *ngIf="ValidationHelperService.isInvalid(userForm.controls.firstName)">
              {{ ValidationHelperService.getErrorMessage(userForm.controls.firstName) }}
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Last name</mat-label>
            <input
              matInput
              type="text"
              [formControl]="userForm.controls.lastName"
              placeholder="Last name"
            />
            <mat-error *ngIf="ValidationHelperService.isInvalid(userForm.controls.lastName)">
              {{ ValidationHelperService.getErrorMessage(userForm.controls.lastName) }}
            </mat-error>
          </mat-form-field>
        </div>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Email</mat-label>
          <i class="material-icons field-icon" matPrefix>mail_outline</i>
          <input
            matInput
            type="email"
            [formControl]="userForm.controls.email"
            placeholder="name@company.com"
          />
          <mat-error *ngIf="ValidationHelperService.isInvalid(userForm.controls.email)">
            {{ ValidationHelperService.getErrorMessage(userForm.controls.email) }}
          </mat-error>
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="full-width"
          *ngIf="action === EAction.Add"
        >
          <mat-label>Username</mat-label>
          <i class="material-icons field-icon" matPrefix>alternate_email</i>
          <input
            matInput
            type="text"
            [formControl]="userForm.controls.username"
            placeholder="At least 7 characters"
            (blur)="checkUsername()"
          />
          <i
            class="material-icons field-status field-status--ok"
            matSuffix
            *ngIf="alreadyExists === 1 && !ValidationHelperService.isInvalid(userForm.controls.username)"
          >
            check_circle
          </i>
          <mat-hint *ngIf="alreadyExists === 1">This username is available.</mat-hint>
          <mat-error *ngIf="ValidationHelperService.isInvalid(userForm.controls.username)">
            {{ ValidationHelperService.getErrorMessage(userForm.controls.username) }}
          </mat-error>
          <mat-error *ngIf="alreadyExists == -1">
            This username has already been taken.
          </mat-error>
        </mat-form-field>
      </section>

      <section class="form-section">
        <div class="form-section__head">
          <h3 class="form-section__title">Access</h3>
          <mat-checkbox
            *ngIf="action === EAction.Edit"
            class="locations-select-all"
            [checked]="areAllLocationsSelected"
            [indeterminate]="hasPartiallySelectedLocations"
            [disabled]="locations.length === 0"
            (change)="toggleAllLocations($event.checked)"
          >
            Select all
          </mat-checkbox>
        </div>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Locations</mat-label>
          <mat-select
            multiple
            (click)="userForm.controls.locations.markAsUntouched()"
            placeholder="Choose one or more locations"
            [formControl]="userForm.controls.locations"
          >
            <mat-option *ngFor="let option of locations" [value]="option">
              {{ option.name }}
            </mat-option>
          </mat-select>
          <mat-hint *ngIf="locations.length">
            {{ selectedLocationsCount }} of {{ locations.length }} selected
          </mat-hint>
          <mat-error *ngIf="ValidationHelperService.isInvalid(userForm.controls.locations)">
            {{ ValidationHelperService.getErrorMessage(userForm.controls.locations) }}
          </mat-error>
          <mat-error *ngIf="errorLocations">
            You need to select at least one location
          </mat-error>
        </mat-form-field>

        <div class="admin-card" [class.admin-card--on]="userForm.controls.isOrganizationAdmin.value">
          <div class="admin-card__text">
            <p class="admin-card__title">Organization administrator</p>
            <p class="admin-card__hint">
              Admins can manage team members, locations and billing settings.
            </p>
          </div>
          <mat-slide-toggle
            formControlName="isOrganizationAdmin"
            aria-label="Organization administrator"
          ></mat-slide-toggle>
        </div>
      </section>
    </div>

    <footer class="user-dialog__footer">
      <button type="button" mat-stroked-button mat-dialog-close [disabled]="isLoading">
        Cancel
      </button>
      <button mat-flat-button color="primary" class="submit-button" [disabled]="isLoading">
        <mat-spinner *ngIf="isLoading" diameter="18" color="accent"></mat-spinner>
        <span>{{ action === EAction.Add ? "Add user" : "Save changes" }}</span>
      </button>
    </footer>
  </form>
</div>
